module.exports = require("bluebird");


//////////////////
// WEBPACK FOOTER
// external "bluebird"
// module id = 4
// module chunks = 0